import { memo } from 'react'
import Skeleton from '@material-ui/lab/Skeleton'

const HeaderSkeleton = () => <Skeleton variant="rect" height={64} />

export default memo(HeaderSkeleton)
